/**
 * A fixed cost that is valid over a period, rather than a single current amount
 * on the car.
 *
 * Road tax is re-indexed every January and the electric rate stepped from 25%
 * to 70%, an insurance premium changes per policy year, a lease instalment
 * changes when the contract does. With one current amount every one of those
 * silently rewrites the whole cost history; with dated intervals a cost over an
 * older month uses the rate that actually applied then, and the change itself
 * becomes readable: "+ € 14,20 per quarter as of 01-01-2026".
 */
export const TARIEF_SOORTEN = [
    { soort: 'MRB', label: 'Wegenbelasting', periode: 'KWARTAAL' },
    { soort: 'VERZEKERING', label: 'Verzekering', periode: 'JAAR' },
    { soort: 'LEASE', label: 'Lease/leen', periode: 'MAAND' },
];
//# sourceMappingURL=tarief.js.map